export const noticeClasses = '!bg-sub !border-0 !p-4';
